import Reflux from "reflux";

export default {
    uploadFile: Reflux.createAction({ sync: false })
};
